import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth-service';
import { LoginService } from './login-service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private l_loginService: LoginService, private router: Router) {}

  canActivate(): boolean {
    if (this.l_loginService.isAuthenticatedUser()) {
      return true;
    } else {
      this.l_loginService.logout();
      this.router.navigate(['/login']);
      return false;
    }
  }
}
